import './page-layout.scss';

const PageLayout = ({ children }) => (
    <main className="page-layout">{children}</main>
);

export default PageLayout;
